import { GetterTree } from 'vuex';
import { StatisticsState, Search } from './types';
import { RootState } from '../types';

export const getters: GetterTree<StatisticsState, RootState> = { 
  getParameters(state): Search { //SearchState 그대로 내보내준다.
    return state.parameters;
  },
  getLists(state): any {
    return state.list;
  },
  getStatistics(state): any {
    return state.statistics; // 키안에 value만 내보냄 
  }
};
//실제로 셋팅된 정보를 모두 불러오는 곳